export default __webpack_public_path__ + "static/media/bg.6d611c82.mp4";